import classes from "./Input.module.css";
import React from "react";

const Input = React.forwardRef((props, ref) => {
  return (
    <div className={classes.input}>
      <label htmlFor={props.input.id}>{props.label}</label>
      {/* kis input ka label hai yeh btane k we use forhtml attribute here */}
      <input ref={ref} {...props.input} />
      {/* forward ref */}
    </div>
  );
});

export default Input;
